<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <oxd-input-field
    type="autocomplete"
    :model-value="modelValue"
    :label="label"
    :clear="false"
    :required="required"
    :create-options="loadSupervisors"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>

<script>
import {formatEmployeeFullName} from '@/core/util/helper/employeeDisplayName';
import {APIService} from '@ohrm/core/util/services/api.service';

export default {
  name: 'LeaveSupervisorAutocomplete',

  props: {
    modelValue: {
      type: Object,
      default: null,
    },
    empNumber: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:modelValue', 'supervisors-loaded'],

  data() {
    return {
      supervisorOptions: [],
    };
  },

  computed: {
    http() {
      return new APIService(
        window.appGlobal.baseUrl,
        `/api/v2/pim/employees/${this.empNumber}/supervisors`,
      );
    },
  },

  watch: {
    empNumber: {
      handler() {
        this.loadSupervisorList();
      },
      immediate: true,
    },
  },

  methods: {
    loadSupervisorList() {
      if (!this.empNumber) {
        this.supervisorOptions = [];
        this.$emit('supervisors-loaded', 0);
        return;
      }

      this.http
        .getAll({limit: 100})
        .then(({data}) => {
          this.supervisorOptions = (data.data ?? [])
            .filter((item) => !item.supervisor?.terminationId)
            .map((item) => ({
              id: item.supervisor.empNumber,
              label: formatEmployeeFullName(item.supervisor),
            }));
          this.$emit('supervisors-loaded', this.supervisorOptions.length);
        })
        .catch(() => {
          this.supervisorOptions = [];
          this.$emit('supervisors-loaded', 0);
        });
    },
    async loadSupervisors(searchParam) {
      const query = searchParam.trim().toLowerCase();
      if (!query) {
        return [...this.supervisorOptions];
      }
      return this.supervisorOptions.filter((option) =>
        option.label.toLowerCase().includes(query),
      );
    },
  },
};
</script>
